import { DispatchType, StoreAction, StoreState } from "../reduxTypes";
import { parseError } from "../../utils/http-helper";
import inicializarService from "../../services/inicializacao";
import loginActions from "../login/actions";

export const SESSION__START_LOADING = "SESSION__START_LOADING";
export const SESSION__STOP_LOADING = "SESSION__STOP_LOADING";
export const SESSION__SET_SESSION_CONFIGS = "SESSION__SET_SESSION_CONFIGS";
export const SESSION__UPDATE_SESSION = "SESSION__UPDATE_SESSION";

const sleep = (delay: number) =>
  new Promise((resolve) => setTimeout(resolve, delay));

function startLoading(): StoreAction {
  return {
    type: SESSION__START_LOADING,
  };
}
function stopLoading(): StoreAction {
  return {
    type: SESSION__STOP_LOADING,
  };
}

function setConfigs(configs: Object): StoreAction {
  return {
    type: SESSION__SET_SESSION_CONFIGS,
    payload: configs,
  };
}

function updateSession(session: Object): StoreAction {
  return {
    type: SESSION__UPDATE_SESSION,
    payload: session,
  };
}

function getSessionConfigs() {
  return async function (dispatch: DispatchType, getState: () => StoreState) {
    while (getState().configsState.loading) await sleep(200);

    dispatch(startLoading());
    try {
      const respConfigs = await inicializarService.inicializar();
      await sleep(2000);
      dispatch(setConfigs(respConfigs.data));
    } catch (error) {
      parseError(error, "Erro ao tentar conectar");
    }
  };
}

function updateSessionData(CPF: string) {
  return async function (dispatch: DispatchType, getState: () => StoreState) {
    while (getState().configsState.loading) await sleep(200);
    try {
      const resp = await inicializarService.renovarUsuario(CPF);
      await sleep(2000);
      dispatch(updateSession(resp.data));
      loginActions.setTempSession(resp.data);
      loginActions.setSession();
    } catch (error) {
      parseError(error, "Erro ao tentar conectar");
    } finally {
      dispatch(stopLoading());
    }
  };
}

const sessionConfigsActions = {
  getSessionConfigs,
  updateSessionData,
};

export default sessionConfigsActions;
